import React, {Component} from 'react';
import { BrowserRouter, Route, Switch, Redirect,withRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Home from './Pages/Home';
import UserLogin from './Pages/User/UserLogin';
import UserSignup from './Pages/User/UserSignup';
import ScrollRestoration from './components/ScrollRestoration';
import TaskerView from './Pages/User/Booking/Market/TakerView';
import Booking from './Pages/User/Booking/Booking';
import Chat from './components/ChatModules/Chat';
import ContactUs from './components/AdditionalPages/ContactUs';
import Help from './components/AdditionalPages/Help';
import PrivacyPolicy from './components/AdditionalPages/PrivacyPolicy';
import TermsCondition from './components/AdditionalPages/TermsaAndCondition';
import TaskerTermsCondition from './components/AdditionalPages/TaskerTermsCondition';
import UserMyBooking from './Pages/User/Booking/UserMyBooking';
import UserMyListing from './Pages/User/Booking/UserMyListing';
import MyBookingDetail from './Pages/User/Booking/MyBookingDetail';
import MyBookingTracker from "./components/Directions/DirectionsIndex";
import PostTask from './Pages/User/PostTask';
import EditNeed from './Pages/User/EditNeed';
import TaskerLogin from './Pages/Tasker/TaskerLogin';
import TaskerSignup from './Pages/Tasker/TaskerSignup';
import UpdateBio from './Pages/Tasker/UpdateBio';
import UserJobs from './Pages/Tasker/UserJobs';
import TaskerHome from './Pages/Tasker/TaskerHome/TaskerHome';
import MyServices from './Pages/Tasker/MyServices/MyServices';
import MyServiceDetail from './Pages/Tasker/MyServices/MyServiceDetail';
import MyVerification from './Pages/Tasker/MyVerification';
import MyNeeds from './Pages/User/Needs/MyNeeds';
import BrowseTaskDetail from './Pages/Tasker/BrowseTask/BrowseTaskDetail';
import TaskerMyBooking from './Pages/Tasker/MyBooking/TaskerMyBooking';
import TaskerBookingConfirm from './Pages/Tasker/MyBooking/TaskerBookingConfirm';
import MyServiceView from './Pages/Tasker/MyServices/MyServiceView';
import MyPortfolio from './Pages/Tasker/MyPortfolio';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import NotFound from './components/NotFound';
import AddServices from './Pages/Tasker/MyServices/AddServices';
import ProHowItWork from './Pages/User/ServiceProInnerPages/ProHowItWork';
import MarketPlace from './Pages/User/ServiceProInnerPages/MarketPlace';
import SubCategoryLists from './Pages/User/ServiceProInnerPages/SubCategoryLists';
import Header from './components/Header';
import BusinessHeader from './components/BusinessHeader';
// import {WithRouter} from './components/WithRouter';
import Footer from './components/Footer';
import axios from 'axios';
import {loggedin} from './redux/actions';
import {connect} from 'react-redux';
import firebase from './components/firebase';
import UpdatePaymentStatus from './Pages/User/Booking/UpdatePaymentStatus';
import UpdatePayoutInfo from './Pages/Tasker/UpdatePayoutInfo';
import BusinessViewPage from './Pages/User/ServiceProInnerPages/BusinessViewPage';
import BusinessViewAll from './Pages/User/ServiceProInnerPages/BusinessViewAll';
import BusinessSearchPage from './Pages/User/ServiceProInnerPages/BusinessSearchPage';
import ChatPage from './components/ChatModules/ChatPage';
import MyListingDetail from './Pages/User/Booking/MyListingDetail';

const mapStateToProps=(props)=> {
  return {
      loginvalue : props.isLogged
  }
}

const mapDispatchToProps=(dispatch)=> {
  return {
      loggedin : (userdata)=>dispatch(loggedin(userdata))
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_info : localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null,
    current_path : props.location.pathname
    }
    this.location = this.props;
    this.get_appdefault = this.get_appdefault.bind(this)
  }


  UNSAFE_componentWillMount = () => {
    window.scrollTo(0, 0);
    this.get_appdefault();
    // const {location} = this.props;
    // console.log('locate',location)
    // setTimeout(() => {
      this.update_device_token()
    // }, 3000);
    if(localStorage.getItem('user') !== null) {
      this.setState({ user_info : JSON.parse(localStorage.getItem('user')) });
    }
  }
  componentDidUpdate (prevProps){
    console.log('prevProps',prevProps.location.pathname)
    console.log('afterProps',this.props.location.pathname)
    if(prevProps.location.pathname !== this.props.location.pathname){
      this.setState({current_path : this.props.location.pathname})
    }
  }

  // update_device_token = () => {
  //   if(localStorage.getItem('device_token') === null) {
  //     const messaging = firebase.messaging()
      
  //     if ("serviceWorker" in navigator) {


  //       navigator.serviceWorker
  //         .register("./firebase-messaging-sw.js")
  //         .then(function(registration) {
  //           messaging.useServiceWorker(registration);
  //           messaging.requestPermission().then(()=>{
  //             return messaging.getToken()
  //           }).then(token => {
  //               localStorage.setItem('device_token',token);
  //           }).catch((error)=>{
  //               console.log(error)
  //           })
  //         })
  //         .catch(function(err) {
  //           console.log('registration_err',err);
  //           console.log("Service worker registration failed, error:", err);
  //         });



  //     }
  //   }
  // }



  

  update_device_token = () => {
    if (!localStorage.getItem("device_token")) {
      // ✅ Initialize Firebase directly here
      const firebaseConfig = {
        apiKey: "AIzaSyCrUQvHrXPWOO2d88bMV3wSjoXeBwopiXI",
        authDomain: "empleos-cl.firebaseapp.com",
        projectId: "empleos-cl",
        storageBucket: "empleos-cl.firebasestorage.app",
        messagingSenderId: "625871340522",
        appId: "1:625871340522:web:66e5486cdfc06adfafa893",
      };
  
      // Initialize Firebase (prevent duplicate initialization)
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      } else {
        firebase.app();
      }
  
      const messaging = firebase.messaging();
  
      // if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/web/firebase-messaging-sw.js", { scope: "/web/" })
          // .register("/firebase-messaging-sw.js")
          .then((registration) => {
            messaging.useServiceWorker(registration);
  
            return messaging.requestPermission()
              .then(() => messaging.getToken())
              .then((token) => {
                if (token) {
                  console.log("FCM Token:", token);
                  localStorage.setItem("device_token", token); // ✅ Save token
                } else {
                  console.log("No FCM token received.");
                }



                
              })
              .catch((error) => {
                console.error("Error getting FCM token:", error);
              });   
          })
          .catch((err) => {
            console.error("Service worker registration failed:", err);
          });
      // }
    }
  };
  



  async get_appdefault(){ 
    if(localStorage.getItem('general_info') !== null) {
      // localStorage.removeItem('general_info');
    }
    await axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/appdefaults`)
    .then(res => {
        if(res.data.status_code === 200)
        {
          var link = document.querySelector("link[rel~='icon']");
          if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.getElementsByTagName('head')[0].appendChild(link);
          }
          link.href = res.data.site_favicon;
          localStorage.setItem('general_info', JSON.stringify(res.data));
          console.log('res.data',res.data);
          this.setState({ general_info : res.data });
        }
        else {
            this.setState({ general_info : {} });
        }
    });
  }
  render() {
    // const { location } = this.props;
    // console.log('locate',location)


    return (
      <div className="App">
          < >
          
{/* Conditionally render headers */}

      
               {/* <div>
                {this.state.current_path.includes("business/viewall") ? (
                    <BusinessHeader />
                ) : (
                    <Header user={this.state.user_info} />
                )}
            </div> */}


<div>
    {this.state.current_path.includes("business/viewall") || 
     this.state.current_path.includes("business/search-results") ? (
        <BusinessHeader />
    ) : (
        <Header user={this.state.user_info} />
    )}
</div>


            <ScrollRestoration />
            <div className="center_pos">
              <div>
                <Switch>
                  {/* these routes working with out login */}
                  <Route exact path="/" component={(props) => this.state.user_info === null ? (<Home {...props}/>) : this.state.user_info && this.state.user_info.type === 'user' ? (<Home {...props}/>) : this.state.user_info.type === 'tasker' && <Redirect to="/tasker"/> } />
                  
                  <Route exact path="/user/sub-categories/:cat_id" component={(props) => this.state.user_info === null ? (<SubCategoryLists {...props}/>) : this.state.user_info && this.state.user_info.type === 'user' ? (<SubCategoryLists {...props}/>) : this.state.user_info.type === 'tasker' && <Redirect to="/tasker"/> } />
                 
                  <Route exact path="/business/search-results" component={BusinessSearchPage} />

                  
                  <Route exact path="/user/business-view/:booking_id" component = {BusinessViewPage}/>
                  
                  <Route exact path="/business/viewall" component = {BusinessViewAll}/>


                  <Route exact path="/user/user-login" component={(props) => this.state.user_info === null ? (<UserLogin {...props}/>) : this.state.user_info.type === 'tasker' ? <Redirect to="/tasker"/> : <Redirect to="/"/>} />
                  <Route exact path="/user/user-signup" component={(props) => this.state.user_info === null ? (<UserSignup {...props}/>) : <Redirect to="/"/>} />
                  <Route exact path="/forgotPassword/:role_flag" component={ForgotPassword} />
                  <Route exact path="/reset-password/:user_id/:token" component={ResetPassword} />
                  <Route exact path="/tasker/tasker-login" component={(props) => this.state.user_info === null ?  (<TaskerLogin {...props}/>) : this.state.user_info.type === 'tasker' ? <Redirect to="/tasker"/> : <Redirect to="/"/>} />
                  <Route exact path="/tasker/tasker-signup" component={(props) => this.state.user_info === null ? (<TaskerSignup {...props}/>) : <Redirect to="/tasker"/>} />
                  <Route exact path="/user/professional-view/:cat_id/:sub_cat_id" component={(props) => this.state.user_info === null ? (<ProHowItWork {...props}/>) : this.state.user_info && this.state.user_info.type === 'user' ? (<ProHowItWork {...props}/>) : this.state.user_info.type === 'tasker' && <Redirect to="/tasker"/>} />
                  
                  <Route exact path="/user/marketplace-view/:cat_id/:sub_cat_id" component={(props) => this.state.user_info === null ? (<MarketPlace {...props}/>) : this.state.user_info && this.state.user_info.type === 'user' ? (<MarketPlace {...props}/>) : this.state.user_info.type === 'tasker' && <Redirect to="/tasker"/>} />
                  {/* these routes working with out login */}

                  <Route exact path="/help" component={() => (<Help user_info={this.state.user_info ? this.state.user_info : {} } />)} />
                  <Route exact path="/contactus/:helps_flag" component={() => (<ContactUs user_info = {this.state.user_info ? this.state.user_info : {}} />) } />
                  <Route exact path="/privacy-policy" component={() => (<PrivacyPolicy pri_pol_name = { this.state.user_info && this.state.user_info.type === 'tasker' ? this.state.help_info && this.state.help_info.items[1].name : this.state.help_info && this.state.help_info.items[0].name } pri_pol_description = { this.state.user_info && this.state.user_info.type === 'tasker' ? this.state.help_info && this.state.help_info.items[0].description : this.state.help_info && this.state.help_info.items[1].description } />) }  />
                  <Route exact path="/terms-condition" component={() => (<TermsCondition tandc_name = { this.state.user_info && this.state.user_info.type === 'tasker' ? this.state.help_info && this.state.help_info.items[0].name : this.state.help_info && this.state.help_info.items[1].name } tandc_description = { this.state.user_info && this.state.user_info.type === 'tasker' ? this.state.help_info && this.state.help_info.items[0].description : this.state.help_info && this.state.help_info.items[1].description } />)} />

                  <Route exact path="/tasker-terms-condition" component={() => (<TaskerTermsCondition />)} />

                  {/* these routes working with user login only */}
                  <Route exact path="/user/tasker-view/:tasker_id" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<TaskerView {...props}/>) : (<Redirect to="/user/user-login"/>)} />
                  <Route exact path="/user/booking" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<Booking {...props}/>) : (<Redirect to="/user/user-login"/>)} />

                  <Route exact path="/user/updatepaymentstatus/:payment_type/:booking_id/:session_id" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<UpdatePaymentStatus {...props}/>) : (<Redirect to="/user/user-login"/>)} />
                  {/* <Route exact path="/user/updatepaymentstatus/:payment_type/:booking_id/:session_id" component={UpdatePaymentStatus} /> */}

                  <Route exact path="/user/my-booking" component={ (props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<UserMyBooking {...props}/>) : (<Redirect to="/user/user-login"/>) } />
                  <Route exact path="/user/my-listing" component={ (props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<UserMyListing {...props}/>) : (<Redirect to="/user/user-login"/>) } />
                  <Route exact path="/user/my-listing/detail" component={ (props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<MyListingDetail {...props}/>) : (<Redirect to="/user/user-login"/>) } />

                  <Route exact path="/user/my-booking/detail" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<MyBookingDetail {...props}/>) : (<Redirect to="/user/user-login"/>)} />

                  <Route exact path="/user/my-booking/tracker" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<MyBookingTracker {...props}/>) : (<Redirect to="/user/user-login"/>)} />

                  <Route exact path="/user/post-task" component={PostTask} />
                  <Route exact path="/chatpage" component={ChatPage} />

                  <Route exact path="/user/my-needs" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<MyNeeds {...props}/>) : (<Redirect to="/user/user-login"/>)} />
  
                  <Route exact path="/user/edit-need" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'user' ? (<EditNeed {...props}/>) : (<Redirect to="/user/user-login"/>)} />
                  
                  <Route exact path="/chat" component={(props) => this.state.user_info && this.state.user_info.type !== undefined ? (<Chat {...props}/>) : (<Redirect to="/user/user-login"/>)} />

                  {/* these routes working with user login only */}

                  {/* these routes working with tasker login only */} 
                  <Route exact path="/tasker" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<TaskerHome {...props} user_info = {this.state.user_info ? this.state.user_info : {}} general_info = {this.state.general_info ? this.state.general_info : {}} />) : (<Redirect to="/tasker/tasker-login"/>) } />

                  <Route exact path="/browse-task/detail" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<BrowseTaskDetail {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  
                  <Route exact path="/tasker/my-services" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<MyServices {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />

                  <Route exact path="/tasker/my-service-detail/:cat_id" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<MyServiceDetail {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />

                  <Route exact path="/tasker/my-verification" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<MyVerification {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  
                  <Route exact path="/tasker/my-booking" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<TaskerMyBooking {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  <Route exact path="/tasker/my-booking/detail" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<TaskerBookingConfirm {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  <Route exact path="/tasker/my-service/view" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<MyServiceView {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  <Route exact path="/tasker/my-portfolio" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<MyPortfolio {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  {/* <Route exact path="/tasker/add-services" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<AddServices {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} /> */}
                  <Route exact path="/tasker/add-services" component={AddServices} />
                  <Route exact path="/tasker/user-jobs" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<UserJobs {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  
                  <Route exact path="/tasker/update-bio" component={(props) => this.state.user_info && this.state.user_info.type !== undefined && this.state.user_info.type === 'tasker' ? (<UpdateBio {...props} />) : (<Redirect to="/tasker/tasker-login"/>)} />
                  
                  <Route exact path="/tasker/update-payout" component={UpdatePayoutInfo} />
                  {/* these routes working with tasker login only */}
                  <Route component={NotFound} />
                </Switch>
              </div>
              <Footer general_info={this.state.general_info} />
              
            </div>
          </>
      </div>
    );
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(App));

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
